import { useState, useEffect } from "react";
import { breakpoints } from "../theme";
import throttle from "lodash.throttle";

const parseBreakpoint = (value: string): number =>
  parseInt(value.replace("px", ""), 10);

export function useWindowSize() {
  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
    isXs: false,
    isSm: false,
    isMd: false,
    isLg: false,
  });

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      const height = window.innerHeight;
      setWindowSize({
        width,
        height,
        isXs: width < parseBreakpoint(breakpoints.sm),
        isSm:
          width >= parseBreakpoint(breakpoints.sm) &&
          width < parseBreakpoint(breakpoints.md),
        isMd:
          width >= parseBreakpoint(breakpoints.md) &&
          width < parseBreakpoint(breakpoints.lg),
        isLg: width >= parseBreakpoint(breakpoints.lg),
      });
    };

    const throttledResize = throttle(handleResize, 500);
    window.addEventListener("resize", throttledResize);
    handleResize();

    return () => window.removeEventListener("resize", throttledResize);
  }, []);

  return windowSize;
}
